import { css, type Component } from "dreamland/core";
import { Notification } from "../api";
import { clearNotifications, getNotifications } from "../api/notifications";
import StatusView from "../components/Status";
import humanizeDuration from "humanize-duration";
import { Link } from "dreamland/router";

const Notifications: Component<{}, {notifs: Notification[]}> = function (cx) {
    this.notifs = [];
    cx.mount = async () => {
        this.notifs = await getNotifications();
    }

    const notifToIcon = {
        "follow": "person_add",
        "follow_request": "person_add_alt_1",
        "mention": "alternate_email",
        "reblog": "repeat",
        "favourite": "favorite",
        "poll": "poll",
        "status": "chat_bubble",
        "update": "system_update",
        "admin.sign_up": "admin_panel_settings",
        "admin.report": "report_problem",
        "emoji_reaction": "insert_emoticon"
    };

	return (
		<div class="page">
            <div class="notif-header">
                <h1>Notifications</h1>
                <span class="notif-btns">
                    <button on:click={async () => {
                        await clearNotifications();
                        this.notifs = await getNotifications();
                    }}>
                        <span class="material-symbols-sharp">clear_all</span>
                        Clear
                    </button>
                    <button on:click={async () => {
                        this.notifs = [];
                        this.notifs = await getNotifications();
                    }}>
                        <span class="material-symbols-sharp">refresh</span> 
                        Refresh
                    </button>
                </span>
            </div>
            <ul>
                {use(this.notifs).mapEach((notif) => (
                    <li class="notif-item">
                        <p class="notif-info">
                            <span class="notif-type">
                                <span class="material-symbols-sharp">{notifToIcon[notif.type]}</span>
                                <span>
                                    <strong>{notif.type.charAt(0).toUpperCase() + notif.type.slice(1)}</strong>{" "}from{" "}
                                    <Link href={`/user/${notif.account.id}`}>@{notif.account.acct}</Link>
                                </span>
                            </span>
                            <span class="notif-timestamp">
                                {
                                humanizeDuration(
                                    Date.now() - new Date(notif.created_at).getTime(), 
                                    {  
                                        largest: 1, 
                                        round: true, 
                                        spacer: "",
                                        language: "shortEn", 
                                        // @ts-expect-error types package doesn't include this for some reason
                                        languages: {
                                            shortEn: {
                                            y: () => "y",
                                            mo: () => "mo",
                                            w: () => "w",
                                            d: () => "d",
                                            h: () => "h",
                                            m: () => "m",
                                            s: () => "s",
                                            ms: () => "ms",
                                            }
                                        }
                                        }
                                    )
                                    }
                            </span>
                        </p>
                        {notif.status != null ? (
                            <div class="notif-status-wrapper">
                                <StatusView status={notif.status} />
                            </div>
                        ) : null}
                    </li>
                ))}
            </ul>
		</div>
	);
};

Notifications.style = css`
    .notif-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .notif-timestamp {
        font-size: 0.875em;
        color: #666;
    }

    .notif-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .notif-type {
        display: flex;
        align-items: center;
        gap: 0.25em;
    }

    .notif-type .material-symbols-sharp {
        font-size: 1.25em;
    }

    .notif-btns {
        display: flex;
        gap: 0.5em;
    }

    ul {
        list-style: none;
        padding: 0;
    }

    li {
        padding-block: 1em;
        border-bottom: 1px dotted #ccc;
    }

    .notif-status-wrapper {
        padding: 0.5em;
        /* margin-block: 0.75em; */
        border: 1px solid #ccc;
        margin-top: 1em;
    }
`

export default Notifications;